import { useState } from "react"
import { useSelector } from "react-redux";
import AsyncSelect from 'react-select/async';
import { selectTranslations } from "../../../services/i18n/i18nSlice";
import { searchGroups } from "../UsersApi";
import debounce from 'lodash.debounce';
import { toast } from "react-toastify";

export default function AddGroupInput(props) {

    const [showInput, setShowInput] = useState(false)
    const [selectedGroup, setSelectedGroup] = useState(null)
    const t = useSelector(selectTranslations)

    const _loadOptions =  (pattern, callback) => {
        console.log('call');
        searchGroups({
            ...props?.filters || null,
            pattern: pattern,
        }).then((r) => 
            callback(r.data)
        ).catch((e)=>
            toast.error(t.error.error_loading)
        )   
    }

    const loadOptions = debounce(_loadOptions,300)

    const handleAddUser = () => {
        props.onAddGroup(selectedGroup)
    }
    
    return(
            <div className="add_user_input" open={showInput}> 
                {showInput ?
                    <AsyncSelect 
                        loadOptions={loadOptions} 
                        hidden={!showInput}
                        getOptionLabel={g => `${g.name}`}
                        getOptionValue={g => g.group_id}
                        className="addUserSelect"
                        classNamePrefix="addUserSelect"
                        onChange={setSelectedGroup}
                        isOptionDisabled={g => props?.invalidGroups?.includes(g.group_id)}
                    /> : "" }   
                {showInput ? 
                    <button onClick={handleAddUser} disabled={!selectedGroup}>
                        {props.label}
                    </button>
                :
                    <button onClick={()=>{setShowInput(!showInput)}}>
                        {props?.label}
                    </button>
                }
                
            </div>
    )

}